// icon:bx-right-arrow-alt | Boxicons https://boxicons.com/ | Atisa
import * as React from "react";

function WaypointExpIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      // width="66.179"
      // height="113"
      viewBox="0 -2 68 120"
      fill="currentColor"
      {...props}
    >
      <path
        id="arrow_color"
        data-name="arrow color"
        d="M302.175,115.983l-46.839,46.823a9.669,9.669,0,0,1-13.678,0h0a9.688,9.688,0,0,1-.016-13.694h0l39.971-39.964-39.971-40a9.683,9.683,0,0,1,0-13.678h0a9.688,9.688,0,0,1,13.694,0h0L302.175,102.3a9.821,9.821,0,0,1,2.818,6.851h0a9.8,9.8,0,0,1-2.818,6.835Z"
        transform="translate(-238.814 -52.64)"
      />
    </svg>
  );
}

export default WaypointExpIcon;
